export default __webpack_public_path__ + "static/media/education.446700f9.png";